// extracted by mini-css-extract-plugin
export default {"templateListCard":"PropertyTemplateList_templateListCard__CJfIA","selectedRow":"PropertyTemplateList_selectedRow__Rh50h"};